import {
  CreateItemNoteRequestDto,
  CreateNoteRequestDto,
  GetNoteByItemQueryDto,
  NoteDto,
  UpdateNoteRequestDto,
} from '@act/shared/data-transfer-objects';
import { EndpointDefinition } from '../utils/endpointDefinition';

export const notesRequests = {
  createNotes: EndpointDefinition.post<NoteDto, CreateNoteRequestDto, null>({
    name: 'createNotes',
    route: '/notes',
  }),

  // Fetches the single unified note linked to a parent item (visit, call, etc.).
  getNoteByItem: EndpointDefinition.get<NoteDto, GetNoteByItemQueryDto>({
    name: 'getNoteByItem',
    route: '/notes/by-item',
  }),

  // Creates (or returns the existing) note for a parent item.
  createItemNote: EndpointDefinition.post<
    NoteDto,
    CreateItemNoteRequestDto,
    null
  >({
    name: 'createItemNote',
    route: '/notes',
  }),

  updateNote: EndpointDefinition.patch<
    NoteDto,
    UpdateNoteRequestDto,
    { noteId: number }
  >({
    name: 'updateNotes',
    route: '/notes/:noteId',
  }),

  deleteNote: EndpointDefinition.delete<null, { noteId: number }>({
    name: 'deleteNote',
    route: '/notes/:noteId',
  }),
};
